/*
 * @Author: shiguang
 * @Date: 2023-04-25 10:46:45
 * @LastEditors: yusha
 * @LastEditTime: 2024-06-04 20:33:15
 * @Description: App
 */
import React, { Suspense, useCallback, useEffect, useState } from 'react';
import ja_JP from 'antd/locale/ja_JP';
import ko_KR from 'antd/locale/ko_KR';
import en_GB from 'antd/locale/en_GB';
import { Locale } from 'antd/lib/locale';
import { atom, useAtom } from 'jotai';
import { ConfigProvider } from 'antd';
import { ThemeConfig } from 'antd/lib/config-provider';
import {
    RouterProvider,
    RouterProviderProps,
    createBrowserRouter
} from 'react-router-dom';
import { CustomerDetail, Local } from '@/model';
import { ROUTER_BASENAME } from './config/base';
import routers from './config/router';
import CKBLayout from './common/CKBLayout';

import { getLang, LocalContext } from './i18n/init';

import '@/styles/theme/b2b-css-variable.scss';
import '@/styles/theme/d2c-css-variable.scss';

import { getLocalStorageByKey, getLocalSystemSource } from './utils';
import { togglePlat } from './config/request/interceptors';
import './App.css';

const createRouter = (): RouterProviderProps['router'] => {
    return createBrowserRouter(
        routers.map((item) => {
            const Comp = item.component;
            return {
                element: (
                    <CKBLayout
                        isShowMenu={item.showMenu}
                        isShowHeader={item.showHeader}
                    >
                        <Suspense fallback={<div />}>
                            {Comp && <Comp />}
                        </Suspense>
                    </CKBLayout>
                ),
                path: item.path,
                errorElement: <div>err</div>
            };
        }),
        {
            basename: `/${ROUTER_BASENAME}`
        }
    );
};
// export const atomCustomerDetail = atom<CustomerDetailRespDTO | undefined>(undefined);

export const atomRequestCustomerDetail = CustomerDetail;
export const router = createRouter();

export const getRouter = () => {
    return router;
};
const { langType } = Local;

function App() {
    const [locale, setLocale] = useState<Locale>();
    const [customerDetail, requestCustomerDetail] = useAtom(
        atomRequestCustomerDetail
    );
    const [local] = useAtom(langType);
    const systemSource = customerDetail?.systemSource || getLocalSystemSource();

    useEffect(() => {
        requestCustomerDetail();
    }, [requestCustomerDetail]);
    useEffect(() => {
        const lang = getLang();

        const locale = {
            ja_JP,
            ko_KR,
            en_GB
        }[lang];
        setLocale(locale);
    }, []);

    const getThemeStyle = useCallback(() => {
        let obj: ThemeConfig = {
            token: {
                colorPrimary: '#008060',
                borderRadius: 4,
                controlOutlineWidth: 0
            },
            components: {
                Badge: {
                    boxShadow: '0',
                    boxShadowSecondary: '0',
                    boxShadowTertiary: '0',
                    lineWidth: 0
                },
                Modal: {
                    colorPrimary: '#31c8a2'
                },
                Menu: {
                    // 默认的背景和颜色
                    itemBg: '#008060',
                    itemColor: '#fff',
                    // 选中的背景
                    itemSelectedBg: '#e5f6f2',
                    itemHoverBg: '#e5f6f2',
                    itemHoverColor: '#008060',
                    itemBorderRadius: 4
                },
                Button: {
                    controlOutlineWidth: 0,
                    motionEaseInOutCirc: 'cubic-dezier(0,0,0,0)'
                },
                Wave: {
                    motionEaseInOutCirc: 'cubic-dezier(0,0,0,0)',
                    colorPrimary: '#fff'
                },
                Input: {
                    controlOutlineWidth: 0
                },
                Table: {
                    rowHoverBg: '#F5F7FA'
                }
            }
        };
        if (systemSource === 2) {
            obj = {
                token: {
                    colorPrimary: '#2e4968',
                    borderRadius: 4,
                    controlOutlineWidth: 0
                },
                components: {
                    // Form: {
                    //     colorTextDisabled: '#565656',
                    //     controlItemBgActiveDisabled: '#2e4968',
                    // },
                    Badge: {
                        boxShadow: '0',
                        boxShadowSecondary: '0',
                        boxShadowTertiary: '0',
                        lineWidth: 0
                    },
                    Modal: {
                        colorPrimary: '#1890ff'
                    },
                    Menu: {
                        // 默认的背景和颜色
                        itemBg: '#2e4968',
                        itemColor: '#fff',
                        // 选中的背景
                        itemSelectedBg: '#e5eff9',
                        itemHoverBg: '#e5eff9',
                        itemHoverColor: '#2e4968'
                    },
                    Button: {
                        controlOutlineWidth: 0,
                        motionEaseInOutCirc: 'cubic-dezier(0,0,0,0)'
                    },
                    Wave: {
                        motionEaseInOutCirc: 'cubic-dezier(0,0,0,0)',
                        colorPrimary: '#fff'
                    },
                    Input: {
                        controlOutlineWidth: 0
                    }
                }
            };
        }
        return obj;
    }, [systemSource]);

    useEffect(() => {
        togglePlat(systemSource ?? 1);
    }, [systemSource]);

    return (
        <div id="J_B2B" className="App">
            <LocalContext.Provider value={local}>
                <ConfigProvider locale={locale} theme={getThemeStyle()}>
                    <RouterProvider
                        router={router}
                        fallbackElement={<div>fallbackElement</div>}
                    />
                </ConfigProvider>
            </LocalContext.Provider>
        </div>
    );
}

export default App;
